import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { graphql, compose } from 'react-apollo'
import { Button } from 'reactstrap'
import { ProjectSettingsQuery, SaveProjectSettingMutation } from '../mutations'

class GroupingConfigurationTab extends Component {
  static propTypes = {
    parentId: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired,
    saveProjectSetting: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { minGroupingWeldsLength: '', saved: false }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data.loading && !this.props.data.loading) {
      const project = this.props.data.element
      if (project) this.setState({ minGroupingWeldsLength: project.min_grouping_welds_length || '' })
    }
  }

  handleSave() {
    const { minGroupingWeldsLength } = this.state
    this.props.saveProjectSetting({
      variables: {
        attributes: {
          id: this.props.parentId,
          min_grouping_welds_length: parseInt(minGroupingWeldsLength) || null
        }
      }
    })
      .then(() => {
        this.props.data.refetch()
        this.setState({ saved: true })
        setTimeout(() => this.setState({ saved: false }), 2000)
      })
      .catch(err => console.error('Save setting error', err))
  }

  render() {
    const { data } = this.props
    const { minGroupingWeldsLength, saved } = this.state

    if (data.loading) return <div style={{ padding: '20px' }} />
    if (data.error) return <div style={{ padding: '20px' }}>Error: {data.error.message}</div>

    return (
      <div style={{ padding: '20px', maxWidth: '400px' }}>
        <div className="form-group">
          <label htmlFor="min-grouping-welds-length">Min grouping welds length (mm)</label>
          <input
            id="min-grouping-welds-length"
            type="number"
            className="form-control"
            value={minGroupingWeldsLength}
            onChange={e => this.setState({ minGroupingWeldsLength: e.target.value })}
            placeholder="900"
            min="0"
          />
        </div>
        <Button color="primary" onClick={() => this.handleSave()}>
          {saved ? <span><i className="fa fa-check" style={{ marginRight: '6px' }} />Saved</span> : 'Save'}
        </Button>
      </div>
    )
  }
}

export default compose(
  graphql(ProjectSettingsQuery, {
    options: props => ({
      variables: { project_id: props.parentId },
      fetchPolicy: 'network-only'
    })
  }),
  graphql(SaveProjectSettingMutation, {
    name: 'saveProjectSetting'
  })
)(GroupingConfigurationTab)



// WEBPACK FOOTER //
// ./src/components/Projects/tabs/GroupingConfigurationTab.js